// extracted by extract-css-chunks-webpack-plugin
module.exports = {"nets-agent-status":"nets-agent-status","drop-icon":"drop-icon","pill-agent-title":"pill-agent-title","agent":"agent","bggreen":"bggreen","bgred":"bgred"};